module.exports = __webpack_public_path__ + "static/team-manager-9f2a21a21a29b80a946cbfe66e627233.jpg";